/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  ItemControllerHelperMock,
  ItemControllerHelperMockInterface,
} from "../ItemControllerHelperMock";

const _abi = [
  {
    inputs: [
      {
        internalType: "address[]",
        name: "skillTokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "skillTokenIds",
        type: "uint256[]",
      },
      {
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
    ],
    name: "areSkillsAvailableForHero",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAugmentationProtectiveItem",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "configId",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "items",
        type: "address[]",
      },
      {
        internalType: "uint256[][]",
        name: "tokens",
        type: "uint256[][]",
      },
    ],
    name: "prepareToCombine",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "item",
        type: "address",
      },
    ],
    name: "setAugmentationProtectiveItem",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "configId",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "items",
        type: "address[]",
      },
      {
        internalType: "uint256[][]",
        name: "tokens",
        type: "uint256[][]",
      },
      {
        internalType: "address",
        name: "value",
        type: "address",
      },
    ],
    name: "setPrepareToCombine",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "skillTokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "skillTokenIds",
        type: "uint256[]",
      },
      {
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "value",
        type: "bool",
      },
    ],
    name: "setSkillsAvailableForHero",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "setSkillsAvailableForHeroForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class ItemControllerHelperMock__factory {
  static readonly abi = _abi;
  static createInterface(): ItemControllerHelperMockInterface {
    return new Interface(_abi) as ItemControllerHelperMockInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): ItemControllerHelperMock {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as ItemControllerHelperMock;
  }
}
